import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import AsvContact from "@/pages/asv/AsvContact";
const OldPageLink = () => <Navigate to={`/${window.location.pathname.split("/").pop()}`} replace />;
import AsvPage from "@/pages/asv/AsvPage";
import { Loader2 } from "lucide-react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SeoHead } from "@/lib/seo";
import VendorRegister from "@/pages/platform/VendorRegister";
import PlatformAdmin from "@/pages/platform/PlatformAdmin";
import AsvLayout from "@/pages/asv/AsvLayout";
import AsvHome from "@/pages/asv/AsvHome";
import AsvList from "@/pages/asv/AsvList";
import AsvVenue from "@/pages/asv/AsvVenue";
import AsvCentres from "@/pages/asv/AsvCentres";
import AsvCentre from "@/pages/asv/AsvCentre";
import AsvEvent from "@/pages/asv/AsvEvent";
import AsvGame from "@/pages/asv/AsvGame";
import AsvAccount from "@/pages/asv/AsvAccount";
import AsvAuth from "@/pages/asv/AsvAuth";
import { JoinUser, JoinVendor } from "@/pages/asv/AsvJoin";
import { AsvMockPay, AsvPayReturn } from "@/pages/asv/AsvPay";

const Spinner = () => <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-400" /></div>;

const Protected = () => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to={`/signin?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return <Outlet />;
};

const StripAsv = () => {
  const loc = useLocation();
  return <Navigate to={(loc.pathname.replace(/^\/asv(?=\/|$)/, "") || "/") + loc.search} replace />;
};

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SeoHead />
          <Routes>
            <Route path="/asv/*" element={<StripAsv />} />
            <Route path="/login" element={<Navigate to="/signin" replace />} />
            <Route path="/admin/*" element={<Navigate to="/platform" replace />} />
            <Route path="/cart" element={<Navigate to="/?cart=1" replace />} />
            <Route path="/" element={<AsvLayout />}>
              <Route index element={<AsvHome />} />
              <Route path="venues" element={<AsvList kind="venues" />} />
              <Route path="venues/:slug/:pid" element={<AsvVenue />} />
              <Route path="sport-centres" element={<AsvCentres />} />
              <Route path="sport-centres/:slug" element={<AsvCentre />} />
              <Route path="events" element={<AsvList kind="events" />} />
              <Route path="events/:slug/:eid" element={<AsvEvent />} />
              <Route path="games" element={<AsvList kind="games" />} />
              <Route path="games/:gid" element={<AsvGame />} />
              <Route path="account" element={<AsvAccount />} />
              <Route path="signin" element={<AsvAuth />} />
              <Route path="join/user" element={<JoinUser />} />
              <Route path="join/vendor" element={<JoinVendor />} />
              <Route path="p/:slug" element={<OldPageLink />} />
              <Route path=":slug" element={<AsvPage />} />
              <Route path="contact" element={<AsvContact />} />
              <Route path="pay/return" element={<AsvPayReturn />} />
            </Route>
            <Route path="/pay/:id" element={<AsvMockPay />} />
            <Route path="/register-venue" element={<VendorRegister />} />
            <Route element={<Protected />}>
              <Route path="/platform" element={<PlatformAdmin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}
